import { render, staticRenderFns } from "./PageCharge.vue?vue&type=template&id=4aa0f411"
import script from "./PageCharge.vue?vue&type=script&lang=js"
export * from "./PageCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports